import axios from 'axios';
import { Config } from 'config';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';

export function getAccessToken() {
  const user = Cookies.get('intranetAuthUser');
  if (!user) {
    return null;
  }
  return user;
  // return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtYXJrLmNhbWlsbGVyaWdhbWJpbkBleHA0Mi5jb20iLCJuYW1lIjoiTWFyayBDYW1pbGxlcmkgR2FtYmluIiwiZW1haWwiOiJtYXJrLmNhbWlsbGVyaWdhbWJpbkBleHA0Mi5jb20iLCJleHAiOjE2Nzk0OTk5MTB9.2uoB5F6BVKBJs5anja6CEWVieXX08rff-x2u5pQBuhY';
}

export function getUserData() {
  const token = getAccessToken();
  if (!token) {
    return null;
  }

  const userData = jwt_decode(token) as {
    sub: string;
    // google id
    id: string;
    name: string;
    title: string;
    is_superuser: boolean;
    permissions?: string[];
    group: string;
  };
  if (!userData.name) {
    return null;
  }
  return {
    ...userData,
    token,
  };
}

export function triggerGoogleLogin() {
  const popup = window.open(
    `${Config.API_BASE_URL}`,
    'popup',
    'popup=true,height=600,width=400',
  );
  const checkPopup = setInterval(() => {
    if (!popup || !popup.closed) return;
    popup.close();
    clearInterval(checkPopup);
    window.location.reload();
  }, 1000);
}

export function configureApiErrorHandler() {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error: any) => {
      if (error.response?.status === 401) {
        triggerGoogleLogin();
      }
      const detail = error.response?.data?.detail;
      if (detail) {
        // `detail` may be a plain string or a structured { message, help }
        // object. Build a readable `message` either way (never "[object
        // Object]"), and keep the original `response` on the rejected error so
        // callers can still inspect the status and the full structured detail.
        const message =
          typeof detail === 'string'
            ? detail
            : typeof detail.message === 'string'
            ? detail.message
            : JSON.stringify(detail);
        const wrapped = new Error(message);
        (wrapped as any).response = error.response;
        return Promise.reject(wrapped);
      }
      return Promise.reject(error);
    },
  );
}
